import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import __isEmpty from 'lodash/isEmpty';
import __concat from 'lodash/concat';

import butter from '../../services/butter-client';

import './Home.scss';
import PostListItem from '../../components/PostListItem';
import StartTrialAction from '../../components/StartTrialAction';

const { detect, detectDevice } = require('../../services/detect-browser');
const deviceInfo = {
  browser: detect(),
  device: detectDevice()
};

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      meta: {},
      allPosts: [],
      featuredPost: null,
      categories: []
    };
  }

  componentDidMount() {
    this.getFeaturedPost();
    this.getPosts();
    this.getCategories();

    setTimeout(() => {
      window.dataLayer.push({
        'event': 'virtualPageView',
        'deviceType': deviceInfo.device,
        'deviceOS': deviceInfo.browser.os,
        'page': {
          'title': 'Blog Page: Landing',
          'url': this.props.location.pathname,
        }
      });
    }, 0);
  }

  componentDidUpdate() {
    const dropdown = document.getElementById('dd');
    if (dropdown !== null) {
      dropdown.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        if (dropdown.classList.contains('active')) {
          dropdown.classList.remove('active');
        } else {
          dropdown.classList.add('active');
        }
      });
    }
  }

  getFeaturedPost() {
    butter.tag.retrieve('featured-post', {"include": "recent_posts"}).then((response) => {
      this.setState({ featuredPost: response.data.data.recent_posts[0] });
    });
  }

  getPosts() {
    const page = this.state.meta.next_page ? this.state.meta.next_page : 1;

    butter.post.list({ page: page, page_size: 10 }).then((response) => {
      let allPosts = __concat(this.state.allPosts, response.data.data);

      this.setState({
        allPosts,
        meta: response.data.meta
       });
    });
  }

  getCategories() {
    butter.category.list().then((response) => {
      this.setState({ categories: response.data.data });
    });
  }

  renderFeaturedPost() {
    if (!__isEmpty(this.state.featuredPost)) {
      if (window.outerWidth >= 640) {
        return (
          <PostListItem layout="full" post={this.state.featuredPost} />
        )
      } else {
        return (
          <PostListItem key="0" layout="quarter" post={this.state.featuredPost} />
        )
      }
    }
  }

  render() {
    if (__isEmpty(this.state.allPosts)) {
      return <div>Loading...</div>
    }

    const { next_page } = this.state.meta;

    return (
      <div className="app">
        <Helmet>
          <title>codeSpark Blog | Learn-to-Code tips for Teachers and Parents</title>
          <meta name="description" content="Don't miss out on the Foo Fun in codeSpark Academy. Get free coding tips, unplugged activities and more fun updates from codeSpark Academy from our blog!" />
          <meta name="keywords" content="Kids coding languages, Hour of code, coding for kids, kids apps, kids games, learn to code, STEM, Reading, Math, Elementary school" />
          <meta property="og:title" content="codeSpark Blog" />
          <meta property="og:description" content="Learn-to-code Tips for Teachers and Parents from codeSpark Academy. Don't miss out on the Foo Fun in codeSpark Academy." />
          <meta name="twitter:card" content="app" />
          <meta name="twitter:site" content="@codesparkapp" />
          <meta name="twitter:description" content="Learn-to-code Tips for Teachers and Parents from codeSpark Academy. Don't miss out on the Foo Fun in codeSpark Academy." />
          <meta name="twitter:app:country" content="US" />
          <meta name="twitter:app:id:iphone" content="923441570" />
          <meta name="twitter:app:id:ipad" content="923441570" />
          <meta name="twitter:app:id:googleplay" content="org.codespark.thefoos" />
        </Helmet>
        <div className="page home-page">
          <div className="welcome">
            <h1>codeSpark Blog</h1>
            <p>
              Foo news from Fooville! Updates on new content in codeSpark
              Academy and learn-to-code tips for Parents and Teachers.
            </p>
          </div>
          <div className="featured-container">
            <div className="featured-header">
              <div id="dd" className="filter-drop-wrapper">Filter Categories
                <ul className="dropdown">
                {this.state.categories.map((category, key) => {
                  return (
                    <li key={key}>
                      <Link to={`/category/${category.slug}`}>
                        <i className="icon-user"></i>{category.name}
                      </Link>
                    </li>
                    )
                  })}
                </ul>
              </div>
              <h1>Featured Post</h1>
            </div>
            <div className="featured-posts">
              {this.renderFeaturedPost()}
            </div>
            <div className="all-posts">
              <h3>More Posts</h3>
              {this.state.allPosts.map((post, key) => {
                return (
                  <PostListItem key={key} layout="quarter" post={post} />
                )
              })}
            </div>
          </div>
          { next_page &&
            <div className="load-posts">
              <button onClick={() => this.getPosts()}>Load More</button>
            </div>
          }
          <StartTrialAction />
        </div>
      </div>
    );
  }
}

export default withRouter(Home);
